import type { OfferCargoProcess } from "@/features/offer-cargo-process-status";
import type { Loadable } from "@/shared/lib/loadable";
import { BaseKeyValue } from "@/shared/ui/BaseKeyValue";
import { BaseHeaderWrapper } from "@/shared/ui/base-header-wrapper";
import { ValueWithLabel } from "@/widgets/value-with-label";

export const CompanyInfo = ({
  offerCargoProcess,
}: {
  offerCargoProcess: Loadable<OfferCargoProcess>;
}) => {
  if (offerCargoProcess.status !== "success") {
    return null;
  }

  const company = offerCargoProcess.data.draftOfferCargo.company;

  if (!company) {
    return null;
  }

  return (
    <BaseHeaderWrapper title="荷主情報" maxWidth="628px">
      <BaseKeyValue keyLabel="荷主">
        <ValueWithLabel label="企業名" value={company.name} emphasis />
      </BaseKeyValue>
    </BaseHeaderWrapper>
  );
};
